import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
	selector: 'cv-custom-smartqc-cell',
	templateUrl: './custom-smartqc-cell.component.html',
	styleUrls: ['./custom-smartqc-cell.component.scss']
})
export class CustomSmartqcCellComponent implements ICellRendererAngularComp {
	public cellValue: any;
	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}
}
